import React from 'react';
import { AppContainer } from '@aperza/ac-ui';
import { AcVideoView } from './component/templates/AcVideoView';
import { usePageViewTracking } from './util/usePageViewTracking';
const AppVideoPage = (props) => {
    const { companyContractDisplayId, videoPageHashPath } = props;
    usePageViewTracking();
    return (React.createElement("div", { style: { overflow: 'auto', margin: '-25px 0px 0px 0px' } },
        React.createElement(AppContainer, { noPadding: true },
            React.createElement(AcVideoView, { companyContractDisplayId: companyContractDisplayId, videoPageHashPath: videoPageHashPath }))));
};
export default AppVideoPage;
